import React from "react";
import { useParams } from "react-router-dom";

import Page from "../../components/Page";
import MessageForm from "../../components/sections/message/MessageForm";

const Message = () => {
  const { id } = useParams();
  const title = id ? "Edit message" : "Add message";

  const breadcrumb = [
    {
      path: "/",
      breadcrumbName: "Home",
    },
    {
      path: "/messages",
      breadcrumbName: "Messages",
    },
    {
      path: "",
      breadcrumbName: title,
    },
  ];
  return (
    <>
      <Page title={title} breadcrumb={breadcrumb}>
        <div className="page-container">
          <div className="page-padding-leftRight page-padding-topBottom">
            <MessageForm />
          </div>
        </div>
      </Page>
    </>
  );
};

export default Message;
